import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { HeartRateComponent } from './HeartRate.component';
import { WellnessWrapper } from '../WellnessWrapper.component';
var HeartRate = function () {
    return (_jsx(WellnessWrapper, { children: _jsx(HeartRateComponent, {}) }));
};
export default HeartRate;
